import {
  DEFAULT_GENERAL_OPTIONS,
  DEFAULT_TEXT_STYLE,
  chartColorPalette,
  extendedChartColorPalette,
} from '../ChartWidget.config';
import { extendSeriesData } from '../ChartWidget.helpers';
import { ChartDataSeries } from '../ChartWidget.types';
import { WordCloudWidgetData, WordCloudWordDirection } from './WordCloudWidget.types';

const DEFAULT_WIDTH = 503;
const DEFAULT_HEIGHT = 318;
const DEFAULT_WORD_PADDING = 3;
const DEFAULT_SPIRAL = 'archimedean';

export const COLOR_STEPS = 4;

/**
 * Word Cloud rotation config
 * @see https://api.highcharts.com/highcharts/series.wordcloud.rotation
 *
 */
export const DEFAULT_WORD_DIRECTION: WordCloudWordDirection = WordCloudWordDirection.Horizontal;
export const WORD_DIRECTION_CONFIG = new Map<WordCloudWordDirection, Highcharts.PlotWordcloudRotationOptions>([
  [WordCloudWordDirection.Mixed, { from: 0, to: 90 }],
  [WordCloudWordDirection.Horizontal, { from: 0, to: 0 }],
  [WordCloudWordDirection.Vertical, { from: -90, to: -89 }],
  [WordCloudWordDirection.Diagonal, { from: -45, to: 45 }],
]);

const DEFAULT_WORD_CLOUD_CHART_DATA: Partial<WordCloudWidgetData> = {
  generalOptions: {
    ...DEFAULT_GENERAL_OPTIONS,
    wordDirection: DEFAULT_WORD_DIRECTION,
    padding: DEFAULT_WORD_PADDING,
    rotation: false,
  },
  legend: {
    enabled: false,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      ...DEFAULT_TEXT_STYLE,
      fontWeight: 'bold',
    },
  },
  seriesData: extendSeriesData([
    {
      data: [
        'communicate',
        'charts',
        'infographic',
        'Venngage',
        'accessible',
        'modern',
        'tables',
        'comparisons',
        'graphic',
        'variables',
        'analytical',
        'accessible',
        'statistics',
        'information',
        'study',
        'tool',
        'clearly',
        'efficient',
        'specific',
        'visualization',
        'understand',
        'number',
        'viewed',
        'users',
        'create',
      ],
      name: 'Word',
    },
    {
      name: 'Count',
      data: [
        '5',
        '25',
        '18',
        '20',
        '32',
        '4',
        '1',
        '2',
        '15',
        '2',
        '3',
        '4',
        '2',
        '3',
        '1',
        '20',
        '2',
        '4',
        '1',
        '8',
        '2',
        '4',
        '2',
        '1',
        '3',
      ],
    },
  ] as ChartDataSeries),
  seriesMeta: {
    colors: [...chartColorPalette, ...extendedChartColorPalette],
    colorSteps: COLOR_STEPS,
  },
  xAxis: {
    style: {
      lineColor: '#000',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
    title: {
      text: '',
      style: {
        ...DEFAULT_TEXT_STYLE,
      },
    },
  },
  yAxis: {
    style: {
      lineColor: '#000',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
    title: {
      text: '',
      style: {
        ...DEFAULT_TEXT_STYLE,
      },
    },
  },
  grid: {
    style: {
      lineColor: '#DBDBDB',
    },
  },
};

export { DEFAULT_SPIRAL, DEFAULT_WORD_PADDING, DEFAULT_HEIGHT, DEFAULT_WIDTH, DEFAULT_WORD_CLOUD_CHART_DATA };
